module.exports = __webpack_public_path__ + "img/2鳳山車站.3b81a47d.jpg";